////////////////////////////////////////////////////////////
//     							                          //
//  Program: RoomCategory.jsx                                //
//  Application: Room                                   //
//  Option: to view RoomCategory data                       //
//  Developer: Ashish Kumar                               //
//  Date: 2022-01-10                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Button, Table, Modal, Form, InputGroup } from "react-bootstrap";
import deleteicon from "../../assets/images/delete.svg";
import SimpleReactValidator from "simple-react-validator";
import RoomCategoryService from "../../services/RoomCategoryService";
import modaldeleteicon from "./../../assets/images/delete.svg";
import Alerts from "../common/Alerts";
import pluswIcon from "./../../assets/images/plus.svg";
import { Container } from "react-bootstrap";
import MasterSidebar from "../common/MasterSidebar";
import NoData from "../common/NoData";

export class RoomCategory extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      slug: "",
      //for room category
      addRoomCategoryModal: false,
      editRoomCategoryModal: false,
      deleteRoomCategoryModal: false,
      roomCategoryList: [],
      roomCategoryListTotal: 0,
      room_category_name: "",
      aka_name: "",
      sort_order: "",
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.openAddRoomCategoryModal = this.openAddRoomCategoryModal.bind(this);
    this.openEditRoomCategoryModal = this.openEditRoomCategoryModal.bind(this);
    this.openDeleteRoomCategoryModal =
      this.openDeleteRoomCategoryModal.bind(this);
    this.saveRoomCategory = this.saveRoomCategory.bind(this);
    this.getRoomCategoryDetails = this.getRoomCategoryDetails.bind(this);
    this.updateRoomCategory = this.updateRoomCategory.bind(this);
    this.deleteRoomCategory = this.deleteRoomCategory.bind(this);
  }

  componentDidMount() {
    this.getRoomCategoryData();
  }

  async getRoomCategoryData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var roomCategoryList = [];
    var roomCategoryListTotal = 0;

    let res = await RoomCategoryService.getRoomCategory(
      queryString ? "&" + queryString : ""
    );

    if (global.successStatus.includes(res.status)) {
      roomCategoryList = res.data.data ? res.data.data : [];
      roomCategoryListTotal = roomCategoryList ? roomCategoryList.length : 0;
    }
    this.setState({
      roomCategoryList: roomCategoryList,
      roomCategoryListTotal: roomCategoryListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  saveRoomCategory = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.room_category_name &&
      !this.validator.errorMessages.aka_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        room_category_name: this.state.room_category_name,
        aka_name: this.state.aka_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await RoomCategoryService.createRoomCategory(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddRoomCategoryModal();
        this.setState({
          room_category_name: "",
          aka_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getRoomCategoryData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  async getRoomCategoryDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await RoomCategoryService.getRoomCategoryBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.room_category_name = res.data.room_category_name
          ? res.data.room_category_name
          : "";
        resData.aka_name = res.data.aka_name ? res.data.aka_name : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.status_id = res.data.status_id === 1 ? true : false;
      }
      this.setState(resData);
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  updateRoomCategory = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.room_category_name &&
      !this.validator.errorMessages.aka_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        room_category_name: this.state.room_category_name,
        aka_name: this.state.aka_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await RoomCategoryService.updateRoomCategory(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditRoomCategoryModal();
        this.setState({
          room_category_name: "",
          aka_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getRoomCategoryData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  async deleteRoomCategory(slug) {
    this.setState({ showSpinner: true });
    let res = await RoomCategoryService.deleteRoomCategory(slug);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteRoomCategoryModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });

      this.getRoomCategoryData();
    } else {
      this.closeDeleteRoomCategoryModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  openAddRoomCategoryModal() {
    this.setState({ addRoomCategoryModal: true });
  }

  closeAddRoomCategoryModal() {
    this.setState({ addRoomCategoryModal: false });
    this.setState({
      room_category_name: "",
      aka_name: "",
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openEditRoomCategoryModal(slug) {
    this.getRoomCategoryDetails(slug);
    this.setState({ editRoomCategoryModal: true });
    this.setState({ slug: slug });
  }

  closeEditRoomCategoryModal() {
    this.setState({ editRoomCategoryModal: false });
    this.setState({
      slug: "",
      room_category_name: "",
      aka_name: "",
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openDeleteRoomCategoryModal(slug) {
    this.setState({ deleteRoomCategoryModal: true });
    this.setState({ slug: slug });
  }

  closeDeleteRoomCategoryModal() {
    this.setState({ deleteRoomCategoryModal: false });
    this.setState({ slug: "" });
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "start",
    });
  }

  getTitle() {
    return "Room Category";
  }

  render() {
    return (
      <>
        {/* Room Category card */}
        {/* <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="14"
              id="14"
              onClick={(e) => this.setOpen(!this.state.open, e)}
            >
              Room Category
              <i className="mdi mdi-view-headline"> </i>
              {this.state.open && this.state.eventKey === "14" ? (
                <i className="fas fa-chevron-down"></i>
              ) : (
                <i className="fas fa-chevron-up"></i>
              )}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="14">
            <Card.Body>
              <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
                <Button
                  variant="outline-dark btn-block btn-with-icon"
                  onClick={this.openAddRoomCategoryModal}
                >
                  <img src={pluswIcon} /> Add
                </Button>
              </div>
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="table-responsive">
                <Table hover className="mg-b-0">
                  <thead>
                    <tr>
                      <th className="w-40">Room Category Name</th>
                      <th className="w-40">AKA Name</th>
                      <th className="w-15">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.roomCategoryListTotal > 0 ? (
                      this.state.roomCategoryList.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td
                              className="hand-cursor"
                              onClick={() =>
                                this.openEditRoomCategoryModal(item.slug)
                              }
                            >
                              {item.room_category_name}
                            </td>
                            <td>{item.aka_name}</td>
                            <td>
                              {item.status_id === 1 ? (
                                <b className="active"></b>
                              ) : (
                                <b></b>
                              )}
                            </td>
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteRoomCategoryModal(item.slug)
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          No rows found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card> */}

        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {global.userPermissions.checkPermission(
                          "master-data-add"
                        ) && (
                          <Button
                            variant="outline-dark btn-block btn-with-icon"
                            onClick={this.openAddRoomCategoryModal}
                          >
                            <img src={pluswIcon} /> Add
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      {/* <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
              <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddRoomCategoryModal}
              >
                <img src={pluswIcon} /> Add
              </Button>
            </div> */}
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.roomCategoryListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                            <tr>
                              <th className="w-40">Room Category Name</th>
                              <th className="w-40">AKA Name</th>
                              <th className="w-15">Status</th>
                              {global.userPermissions.checkPermission(
                                "master-data-delete"
                              ) && <th className="text-center">Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.roomCategoryListTotal > 0 ? (
                              this.state.roomCategoryList.map((item, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      className="hand-cursor"
                                      onClick={() => {
                                        global.userPermissions.checkPermission(
                                          "master-data-update"
                                        ) &&
                                          this.openEditRoomCategoryModal(
                                            item.slug
                                          );
                                      }}
                                    >
                                      {item.room_category_name}
                                    </td>
                                    <td>{item.aka_name}</td>
                                    <td>
                                      {item.status_id === 1 ? (
                                        <b className="active"></b>
                                      ) : (
                                        <b></b>
                                      )}
                                    </td>
                                    {global.userPermissions.checkPermission(
                                      "master-data-delete"
                                    ) && (
                                      <td>
                                        <div className="btn-icon-list d-block text-center">
                                          <img
                                            src={deleteicon}
                                            alt="Delete"
                                            onClick={() =>
                                              this.openDeleteRoomCategoryModal(
                                                item.slug
                                              )
                                            }
                                            className="hand-cursor"
                                          />
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" align="center">
                                  There are no room categories added in the
                                  system. You may add them by clicking Add
                                  button.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage(
                            "ROOMCATEGORY"
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add room category popup modal */}
        <Modal
          show={this.state.addRoomCategoryModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddRoomCategoryModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddRoomCategoryModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Room Category</h3>
            <InputGroup className="mt-3">
              <label>Room Category Name</label>
              <Form.Control
                onChange={this.changeHandler}
                name="room_category_name"
                value={this.state.room_category_name}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                maxLength="50"
                autoComplete="off"
                // placeholder="Room Category Name"
              />
            </InputGroup>
            {this.state.errors.room_category_name ? (
              <div className="text-danger">
                {this.state.errors.room_category_name}
              </div>
            ) : (
              this.validator.message(
                "room_category_name",
                this.state.room_category_name,
                "required",
                { className: "text-danger" }
              )
            )}

            <InputGroup className="mt-3">
              <label>AKA Name</label>
              <Form.Control
                onChange={this.changeHandler}
                name="aka_name"
                onKeyPress={global.onKeyPressEvent.alphaNumValidation}
                value={this.state.aka_name}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="AKA Name"
                maxLength="3"
              />
            </InputGroup>
            {this.state.errors.aka_name ? (
              <div className="text-danger">{this.state.errors.aka_name}</div>
            ) : (
              this.validator.message(
                "aka_name",
                this.state.aka_name,
                "required|alpha_num_dash|max:3",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddRoomCategoryModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveRoomCategory}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit popup modal */}
        <Modal
          show={this.state.editRoomCategoryModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditRoomCategoryModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditRoomCategoryModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Room Category</h3>
            <InputGroup className="mt-3">
              <label>Room Category Name</label>
              <Form.Control
                onChange={this.changeHandler}
                name="room_category_name"
                value={this.state.room_category_name}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                maxLength="50"
                autoComplete="off"
                // placeholder="Room Category Name"
              />
            </InputGroup>
            {this.state.errors.room_category_name ? (
              <div className="text-danger">
                {this.state.errors.room_category_name}
              </div>
            ) : (
              this.validator.message(
                "room_category_name",
                this.state.room_category_name,
                "required",
                { className: "text-danger" }
              )
            )}

            <InputGroup className="mt-3">
              <label>AKA Name</label>
              <Form.Control
                onChange={this.changeHandler}
                name="aka_name"
                value={this.state.aka_name}
                className="form-control max_width_100"
                id="inlineFormInput"
                onKeyPress={global.onKeyPressEvent.alphaNumValidation}
                type="text"
                // placeholder="AKA Name"
                maxLength="3"
              />
            </InputGroup>
            {this.state.errors.aka_name ? (
              <div className="text-danger">{this.state.errors.aka_name}</div>
            ) : (
              this.validator.message(
                "aka_name",
                this.state.aka_name,
                "required|alpha_num_dash|max:3",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditRoomCategoryModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.updateRoomCategory}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete popup modal */}
        <Modal
          show={this.state.deleteRoomCategoryModal}
          // onHide={() => {
          //   if (
          //     window.confirm("Are you sure to exit the pop up without delete?")
          //   )
          //     this.closeDeleteRoomCategoryModal();
          // }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closeDeleteRoomCategoryModal()}
              >
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="modal-delete-icon" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteRoomCategoryModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteRoomCategory(this.state.slug)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default RoomCategory;
